import { render, staticRenderFns } from "./CountryListItem.vue?vue&type=template&id=0d5d7b13&scoped=true"
import script from "./CountryListItem.vue?vue&type=script&lang=js"
export * from "./CountryListItem.vue?vue&type=script&lang=js"
import style0 from "./CountryListItem.vue?vue&type=style&index=0&id=0d5d7b13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5d7b13",
  null
  
)

export default component.exports